(function () {
  var ALLOWED_ORIGIN = 'https://calculator.unionstone.ca';
  var RESERVATION_SKU = 'reservation';
  var iframe = document.querySelector('.ai-calculator__iframe');
  var isReserving = false;

  if (!iframe) return;

  function getSkuFromQuery() {
    try {
      var params = new URLSearchParams(window.location.search);
      var sku = params.get('sku');
      return sku && sku.trim() ? sku.trim() : null;
    } catch (error) {
      return null;
    }
  }

  function postSkuToIframe() {
    var sku = getSkuFromQuery();
    if (!sku || !iframe.contentWindow) return;

    iframe.contentWindow.postMessage(
      {
        type: 'union-stone:sku',
        payload: { sku: sku },
      },
      ALLOWED_ORIGIN
    );
  }

  iframe.addEventListener('load', postSkuToIframe);

  function setHeight(height) {
    var value = Number(height);
    if (!value || value < 1) return;
    iframe.style.height = value + 'px';
  }

  function getMessageType(data) {
    if (typeof data === 'string') return data;
    if (data && typeof data === 'object') {
      if (typeof data.type === 'string') return data.type;
      if (typeof data.event === 'string') return data.event;
      if (typeof data.action === 'string') return data.action;
    }
    return null;
  }

  function getMessageHeight(data) {
    if (!data || typeof data !== 'object' || !data.payload) return null;
    if (typeof data.payload.height === 'number') return data.payload.height;
    return null;
  }

  function humanizeKey(key) {
    return String(key)
      .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
      .replace(/[_-]+/g, ' ')
      .replace(/\b\w/g, function (char) {
        return char.toUpperCase();
      })
      .trim();
  }

  function flattenToProperties(value, prefix, properties) {
    properties = properties || {};

    if (value == null) return properties;

    if (Array.isArray(value)) {
      var allPrimitive = value.every(function (item) {
        return item == null || typeof item !== 'object';
      });

      if (allPrimitive) {
        if (prefix) properties[prefix] = value.map(String).join(', ');
        return properties;
      }

      value.forEach(function (item, index) {
        var nextPrefix = prefix ? prefix + ' ' + (index + 1) : String(index + 1);
        flattenToProperties(item, nextPrefix, properties);
      });
      return properties;
    }

    if (typeof value === 'object') {
      Object.keys(value).forEach(function (key) {
        var label = humanizeKey(key);
        var nextPrefix = prefix ? prefix + ' / ' + label : label;
        flattenToProperties(value[key], nextPrefix, properties);
      });
      return properties;
    }

    if (prefix) properties[prefix] = String(value);
    return properties;
  }

  function getFirstPieceSku(project) {
    var rooms = project && project.rooms;
    var pieces =
      Array.isArray(rooms) && rooms[0] && Array.isArray(rooms[0].pieces)
        ? rooms[0].pieces
        : project && project.pieces;

    if (!Array.isArray(pieces) || !pieces[0]) return null;
    return pieces[0].sku || null;
  }

  function getFeaturedImageFromProduct(product) {
    if (!product) return null;

    var image = product.featured_image;
    if (image && typeof image === 'object') image = image.src;
    if (!image && Array.isArray(product.images) && product.images.length) {
      image = typeof product.images[0] === 'object' ? product.images[0].src : product.images[0];
    }
    if (!image) return null;

    if (image.indexOf('//') === 0) image = 'https:' + image;
    return image;
  }

  function findProductBySku(sku) {
    function scanProducts(products) {
      for (var i = 0; i < products.length; i++) {
        var variants = products[i].variants || [];
        for (var j = 0; j < variants.length; j++) {
          if (variants[j].sku === sku) return products[i];
        }
      }
      return null;
    }

    return fetch('/products/' + encodeURIComponent(sku) + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('Product handle not found');
        return response.json();
      })
      .then(function (product) {
        var matched = scanProducts([product]);
        if (!matched) throw new Error('SKU not on product handle');
        return matched;
      })
      .catch(function () {
        function loadPage(page) {
          return fetch('/products.json?limit=250&page=' + page)
            .then(function (response) {
              if (!response.ok) throw new Error('Unable to search products for SKU');
              return response.json();
            })
            .then(function (data) {
              var products = data.products || [];
              var matched = scanProducts(products);
              if (matched) return matched;
              if (products.length < 250) {
                throw new Error('No product variant found with SKU "' + sku + '"');
              }
              return loadPage(page + 1);
            });
        }

        return loadPage(1);
      });
  }

  function findVariantIdBySku(sku) {
    return findProductBySku(sku).then(function (product) {
      var variants = product.variants || [];
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].sku === sku) return variants[i].id;
      }
      throw new Error('No product variant found with SKU "' + sku + '"');
    });
  }

  function getProductFeaturedImageBySku(sku) {
    if (!sku) return Promise.resolve(null);

    return findProductBySku(sku)
      .then(getFeaturedImageFromProduct)
      .catch(function () {
        return null;
      });
  }

  function getCart() {
    return fetch('/cart.js').then(function (response) {
      if (!response.ok) throw new Error('Unable to load cart');
      return response.json();
    });
  }

  function removeExistingReservations(variantId) {
    return getCart().then(function (cart) {
      var updates = {};
      var hasUpdates = false;

      (cart.items || []).forEach(function (item) {
        if (item.variant_id === variantId || item.sku === RESERVATION_SKU) {
          updates[item.key] = 0;
          hasUpdates = true;
        }
      });

      if (!hasUpdates) return cart;

      return fetch(
        FoxTheme.routes.cart_update_url,
        Object.assign({}, FoxTheme.utils.fetchConfig('javascript'), {
          body: JSON.stringify({ updates: updates }),
        })
      ).then(function (response) {
        return response.json();
      });
    });
  }

  function refreshCart(parsedState) {
    return getCart().then(function (cartJson) {
      cartJson.sections = parsedState.sections;
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
      document.dispatchEvent(
        new CustomEvent('product-ajax:added', {
          detail: { product: parsedState },
        })
      );

      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.show === 'function') {
        cartDrawer.show();
      }
    });
  }

  function addReservationToCart(project) {
    if (!project || isReserving) return Promise.resolve();
    isReserving = true;

    var properties = flattenToProperties(project);
    var materialSku = getFirstPieceSku(project);

    return Promise.all([findVariantIdBySku(RESERVATION_SKU), getProductFeaturedImageBySku(materialSku)])
      .then(function (results) {
        var variantId = results[0];
        var materialImage = results[1];

        if (materialImage) {
          properties._image = materialImage;
        }

        return removeExistingReservations(variantId).then(function () {
          return variantId;
        });
      })
      .then(function (variantId) {
        var sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', {
            bubbles: true,
            detail: { sections: sectionsToBundle },
          })
        );

        var body = JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: properties,
            },
          ],
          sections: sectionsToBundle,
          sections_url: window.location.pathname,
        });

        return fetch(
          FoxTheme.routes.cart_add_url,
          Object.assign({}, FoxTheme.utils.fetchConfig('javascript'), { body: body })
        );
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (parsedState) {
        if (parsedState.status) {
          throw new Error(parsedState.description || parsedState.message || 'Unable to add reservation to cart');
        }
        return refreshCart(parsedState);
      })
      .catch(function (error) {
        console.error('[ai-calculator]', error);
        alert(error.message || 'Unable to add reservation to cart');
      })
      .then(function () {
        isReserving = false;
      });
  }

  window.addEventListener('message', function (event) {
    if (event.origin !== ALLOWED_ORIGIN) return;
    if (event.source !== iframe.contentWindow) return;

    var type = getMessageType(event.data);

    if (type === 'union-stone:resize') {
      setHeight(getMessageHeight(event.data));
      return;
    }

    if (type === 'union-stone:reserve') {
      var project = event.data && event.data.payload && event.data.payload.project;
      addReservationToCart(project);
    }
  });
})();
